const T_PREFIX = "clone-item";

export const cloneItemTrns = {
  startDealButton: `${T_PREFIX}.start-deal-btn`,
  addToFavoritesButton: `${T_PREFIX}.add-to-favorites-btn`,
  removeFromFavoritesButton: `${T_PREFIX}.remove-from-favorites-btn`,
  downloadPresentationButton: `${T_PREFIX}.download-presentation-btn`,
  viewPresentationButton: `${T_PREFIX}.view-presentation-btn`,
};

export const cloneItemTitlesTrns = {
  cloneDescription: `${T_PREFIX}.clone-description-title`,
  mainAdvantages: `${T_PREFIX}.main-advantages-title`,
  companyActivities: `${T_PREFIX}.company-activities-title`,
  additionalInformation: `${T_PREFIX}.additional-information-title`,
  presentationTitle: `${T_PREFIX}.presentation-title`,
};
